/**
 * Leakages page — localization manifest.
 */
export const leakagesManifest: readonly string[] = [
  "leakages.title",
  "leakages.category",
  "leakages.riskScore",
  "leakages.resolved",
  "leakages.unresolved",
  "leakages.resolve",
  "leakages.detectedAt",
  // Shared
  "nav.leakages",
  "common.loading",
  "common.noData",
  "common.search",
  "common.filter",
  "common.export",
  "common.actions",
  "common.status",
  "common.amount",
  "severity.all",
  "severity.critical",
  "severity.high",
  "severity.medium",
  "severity.low",
] as const;
